import "core-js/modules/es.array.slice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/companyManage/companyManage';
export default {
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      rules: {
        companyName: [{
          required: true,
          message: '请输入单位名称',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 50 个字符',
          trigger: 'change'
        }],
        companyAddr: [{
          required: true,
          message: '请输入单位地址',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 200 个字符',
          trigger: 'change'
        }],
        companyLegal: [{
          required: true,
          message: '请输入法人代表',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 200 个字符',
          trigger: 'change'
        }],
        companyPhone: [{
          required: true,
          message: '请输入单位电话',
          trigger: 'blur'
        }, {
          min: 1,
          max: 50,
          message: '长度在 1 到 200 个字符',
          trigger: 'change'
        }]
      },
      posId: 0,
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
        });
      } else {
        this.postId = 0;
        this.childData = {};
      }
    },
    handleRemarkInput: function handleRemarkInput(val) {
      if (val.length > 99) {
        this.$message({
          message: '备注的最大长度不能超过100个字符',
          type: 'warning'
        });
      }

      this.$set(this.childData, 'posDesc', val.slice(0, 100));
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function (res) {
              if (res.data.code == 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'update'
                });
              } else {
                _this2.Alert({
                  alertType: 'error',
                  message: res.data.message
                });
              }
            });
          } else {
            fetchCreate(_this2.childData).then(function (res) {
              if (res.data.code == 200) {
                _this2.$emit('handCancle', true);

                _this2.Alert({
                  alertType: 'add'
                });
              } else {
                _this2.Alert({
                  alertType: 'error',
                  message: res.data.message
                });
              }
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  }
};